//api/v1/trend-tracker body (numberOfDirections) [POST]
//api/v1/trend-tracker [GET]

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export async function setTrendTracker(numberOfDirections) {
    const response = await fetch(`${API_URL}/api/v1/trend-tracker`, {
        method: 'POST',
        headers: getAuthHeader(),
        body: JSON.stringify({ numberOfDirections })
    });
    return response;
}

export async function getLatestTrendTracker() {
    const response = await fetch(`${API_URL}/api/v1/trend-tracker`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}